import React from 'react';
import { NotificationManager } from 'react-notifications';
import PropTypes from 'prop-types';
import { Button, Spinner } from 'reactstrap';
import { slug } from '../services/SlugService';

const DownloadButton = (props) => {
  const handleDownload = () => {
    async function download() {
      await props.download();
    }
    if (!props.stillLoading && !props.failed) {
      download();
    }
    if (props.failed) {
      NotificationManager.error(`Failed to load ${props.btnText} data!`);
    }
  };

  const renderLoading = () => {
    if (!props.stillLoading) {
      return null;
    }
    if (props.failed) {
      return (
        <i
          className="fa-solid fa-circle-exclamation fa-lg"
          style={{ color: '#ff8b8b' }}
          title={`Failed to load ${props.btnText} data!`}
          aria-hidden="true"
        />
      );
    }
    return (
      <div>
        <Spinner color="primary">Loading...</Spinner>
      </div>
    );
  };

  return (
    <>
      {renderLoading()}
      <Button
        id={`download-${slug(props.btnText)}-Button`}
        color="secondary"
        className="text-nowrap mx-auto downloadButtom"
        disabled={props.stillLoading || props.failed}
        onClick={handleDownload}>
        {props.btnText}
      </Button>
    </>
  );
};

DownloadButton.propTypes = {
  stillLoading: PropTypes.bool ?? false,
  failed: PropTypes.bool,
  btnText: PropTypes.string,
  download: PropTypes.func,
};

export default DownloadButton;
